import { render } from "./MDocumentViewer.vue?vue&type=template&id=07623817&scoped=true"
import script from "./MDocumentViewer.vue?vue&type=script&lang=js"
export * from "./MDocumentViewer.vue?vue&type=script&lang=js"

import "./MDocumentViewer.vue?vue&type=style&index=0&id=07623817&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07623817"]])

export default __exports__